import * as d3 from 'd3';
import async from 'async';

angular.module("SupportAgent")
.controller(
 'DashboardController',
 ['$rootScope', '$scope', 'gettext',
  'INTRACTABLE','L',
 function ($rootScope,$scope,gettext,INTRACTABLE,L) {
  /* Charts data & options */
  var colorArray = [
   '#5FA2DD', '#4EBCDA', '#9CC96B', '#50C7A7', '#EBAA4B', '#F76C51', '#986291', '#E17CA7',
   '#C3CEDB','#5FA2DD', '#4EBCDA', '#9CC96B', '#50C7A7', '#EBAA4B', '#F76C51', '#986291',
   '#E17CA7', '#C3CEDB'];
  $scope.userChoice = $rootScope.chartChoice;
  $rootScope.menutitle = $rootScope.strings.str_dashboard;
  $scope.userCount = $scope.devicesCount = $scope.supportCount = $scope.resultCount = $rootScope.strings.str_fetching;
  $scope.chartSD = $scope.chartED = undefined;
  $scope.statsSupportData = [];

  function retrieve_data() {
   async.parallel({
    counts: function(cb) {
     async.mapValues({
      userCount: 'user/count',
      devicesCount: 'devices/count',
      supportCount: 'conversation/support/count',
      resultCount: 'test/results/count'
     },function(x,k,cb) {
      INTRACTABLE.request(x,{},function(e,r) {
       if(e) return L.error({err:e,stat:x},"error fetching "+x),cb(e);
       if(r._S=='ok') return cb(null,r.count);
       L.trace({r:r},"error fetching count for "+x);
       cb(new Error('error fetching '+x));
      });
     },cb);
    },//counts
    devices: function(cb) {
     INTRACTABLE.request('/manufacturer/devices/count',{},function(e,r) {
      if(e) return L.trace({err:e},"error fetching devices data"),cb(e);
      if(r._S=='ok') return cb(null,r.data);
      L.trace({r:r},"error fetching manufacturer data");
      cb(new Error('error fetching manufacturer data'));
     });
    },//devices
    usage: function(cb) {
     var today = new Date();
     var todaynt = new Date(today.getFullYear(), today.getMonth(), today.getDate());
     var daybefore90 = todaynt;
     daybefore90.setDate(daybefore90.getDate() - 90);
     var t = [daybefore90,today].map(function(x) {
      return x.getFullYear() + '-' +
       ("0" + (x.getMonth() + 1)).slice(-2) + '-' +
       ("0" + x.getDate()).slice(-2);
     });
     INTRACTABLE.request("usage/os",
      {start: t[0], end: t[1] },
      function (e, r) {
       if(e) return L.trace({err:e},"error fetching usage"),cb(e);
       if(r._S=='ok') return cb(null,{sd:t[0],ed:t[1],usage:r.usage});
       L.trace({r:r},"error fetching os usage");
       cb(new Error('error fetching os usage'));
     });
    }//usage
   },function(e,r) {
    if(e) return L.error({err:e},"error fetching dashboard data");
    Object.assign($scope,r.counts);
    $scope.manufacturerData = r.devices;
    $scope.chartSD = r.usage.sd;
    $scope.chartED = r.usage.ed;
    $scope.usage = r.usage.usage;
    prepareDataForPieChat($scope.manufacturerData);
    fetchData($scope.userChoice);
   });
  }
  if(INTRACTABLE.has_token()) $scope.$applyAsync(retrieve_data);

  $scope.$on('wtg.interact.device.login',function(evt,args) {
   if(!args.status) retrieve_data();
  });

  $rootScope.stopDeviceStatusCheck();
  $scope.statsSupportOptions = {
   chart: {
    type: 'stackedAreaChart',
    height: 300,
    margin: {
     top: 30,
     right: 20,
     bottom: 20,
     left: 40
    },
    noData: $rootScope.strings.str_no_data_available,
    color: function (d, i) {
     return colorArray[i];
    },
    x: function (d) {
     return d[0];
    },
    y: function (d) {
     return d[1];
    },
    useVoronoi: false,
    clipEdge: true,
    transitionDuration: 500,
    useInteractiveGuideline: true,
    xScale: d3.time.scale(), // <-- explicitly set time scale
    xAxis: {
     ticks: d3.time.monday, // <-- add formatter for the ticks
     tickFormat: function (d) {
      return d3.time.format('%d %b')(new Date(d));
     },
    },
    yAxis: {
     tickFormat: function (d) {
      return d3.format('g')(d);
     }
    }
   }
  };
  function fetchData(key) {
   $scope.statsSupportData = [];
   if($scope.usage) $scope.statsSupportData = Object.keys($scope.usage).map(function(os) {
    var item = {};
    item.key = gettext(os + ' ' + key);//TODO: bad localization (also for gettext)
    item.values = [];
    var usage = $scope.usage[os];
    var d1 = new Date($scope.chartSD);
    var d2 = new Date($scope.chartED);
    for (var d = new Date(d1) ; d <= d2; d.setTime(d.getTime() + 1000*60*60*24)) {
     var date = d.getTime();
     var ds = '' + (date / 1000);
     item.values.push([date, usage[ds] ? (key == 'sessions' ? usage[ds].sessions : key == 'users' ? usage[ds].users : key == 'devices' ? usage[ds].clients : 0) : 0]);
    }
    return item;
   });
   if($scope.api) $scope.api.refresh();
  }
  $scope.updateData = function () {
   $rootScope.chartChoice = $scope.userChoice;
   fetchData($scope.userChoice);
  };
  fetchData($scope.userChoice);
  if($scope.manufacturerData) prepareDataForPieChat($scope.manufacturerData);
  $scope.statsManufacturerOptions = {
   chart: {
    type: 'pieChart',
    height: 340,
    margin: {
     left: 0,
     top: 0,
     bottom: -200,
     right: 0
    },
    showLabels: false,
    donut: true,
    x: function(d){return d.name},
    y: function(d){return d.count},
    noData: $rootScope.strings.str_no_data_available,
    color: function (d, i) {
     return colorArray[i];
    },
    pie: {
     startAngle: function(d) { return d.startAngle/2 -Math.PI/2 },
     endAngle: function(d) { return d.endAngle/2 -Math.PI/2 }
    },
    duration: 500,
    legend: {
     margin: {
      top: 5,
      right: 35,
      bottom: 5,
      left: 0
     }
    },
    tooltip: {
     valueFormatter:function(d) {
      return Number(d);
     }
    }
   }
  };
  function prepareDataForPieChat(data) {
   $scope.statsManufacturerData = data.map(function(t) {
    if(!t.name) t.name = $rootScope.strings.unknown_devices;
    return t;
   });
  }
 }]);
